import React from 'react';
import EquipmentSection from './EquipmentSection';
import { useEquipmentLabels } from '../hooks/useEquipment';

export default function EquipmentSpecifications({ id, name, specifications, note }) {
  const label = useEquipmentLabels();
  if (!specifications.length) return null;
  return <EquipmentSection id={id} eyebrow={label('specTitle')} title={label('specTitle')}>
    <div className="equipment-table-wrap">
      <table className="equipment-table">
        <caption>{name} · {label('specTitle')}</caption>
        <tbody>
          {specifications.map(specification => <tr key={specification.id}>
            <th scope="row">{specification.label}</th>
            <td>{specification.value}</td>
          </tr>)}
        </tbody>
      </table>
    </div>
    {note && <p className="equipment-note">{note}</p>}
  </EquipmentSection>;
}
